var _mask, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavRoworkPm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2821_35",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5243 19.0292C20.652 17.2531 21.9994 14.6215 21.9994 11.6845C21.9994 6.33589 17.5309 2 12.0187 2C6.50658 2 2.03809 6.33589 2.03809 11.6845C2.03809 17.0331 6.50658 21.369 12.0187 21.369C13.0069 21.369 13.9616 21.2296 14.863 20.9701L18.8336 21.8853C19.6799 22.0804 20.2843 21.0819 19.719 20.4225L18.5243 19.0292Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5243 19.0292L17.8835 18.2615L17.1056 18.9108L17.7652 19.6801L18.5243 19.0292ZM14.863 20.9701L15.0876 19.9956L14.8352 19.9374L14.5863 20.0091L14.863 20.9701ZM18.8336 21.8853L19.0582 20.9109L18.8336 21.8853ZM19.719 20.4225L20.4781 19.7716V19.7716L19.719 20.4225ZM20.9994 11.6845C20.9994 14.3066 19.7981 16.6633 17.8835 18.2615L19.1652 19.7969C21.506 17.8429 22.9994 14.9363 22.9994 11.6845H20.9994ZM12.0187 3C17.0072 3 20.9994 6.91636 20.9994 11.6845H22.9994C22.9994 5.75543 18.0546 1 12.0187 1V3ZM3.03809 11.6845C3.03809 6.91636 7.03025 3 12.0187 3V1C5.9829 1 1.03809 5.75543 1.03809 11.6845H3.03809ZM12.0187 20.369C7.03025 20.369 3.03809 16.4526 3.03809 11.6845H1.03809C1.03809 17.6135 5.9829 22.369 12.0187 22.369V20.369ZM14.5863 20.0091C13.7741 20.243 12.9126 20.369 12.0187 20.369V22.369C13.1013 22.369 14.1491 22.2163 15.1397 21.931L14.5863 20.0091ZM14.6384 21.9445L18.6089 22.8598L19.0582 20.9109L15.0876 19.9956L14.6384 21.9445ZM18.6089 22.8598C20.3957 23.2716 21.6717 21.1637 20.4781 19.7716L18.9598 21.0734C18.9605 21.0742 18.9549 21.0676 18.9492 21.0533C18.9436 21.0394 18.9403 21.024 18.9395 21.0091C18.938 20.9808 18.9456 20.964 18.9502 20.9565C18.9547 20.9491 18.966 20.9346 18.9918 20.9227C19.0054 20.9165 19.0205 20.9123 19.0355 20.9108C19.0507 20.9092 19.0592 20.9111 19.0582 20.9109L18.6089 22.8598ZM20.4781 19.7716L19.2835 18.3783L17.7652 19.6801L18.9598 21.0734L20.4781 19.7716Z",
    fill: "current",
    mask: "url(#path-1-inside-1_2821_35)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 11.5,
    r: 1.5,
    fill: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.5,
    r: 1.5,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRoworkPm);
export default __webpack_public_path__ + "static/media/navRoworkPM.9440e12d.svg";
export { ForwardRef as ReactComponent };